const REDACTED_VALUE = '[REDACTED]'
const CIRCULAR_REFERENCE = '[Circular]'

const SENSITIVE_KEY_PATTERN = /(pass(word)?|token|auth|authorization|cookie|secret|ssn|member(id|number)?|email|phone)/i

const STRING_REDACTORS: ReadonlyArray<[RegExp, string]> = [
  [/Bearer\s+[A-Za-z0-9\-._~+/]+=*/gi, `Bearer ${REDACTED_VALUE}`],
  [/\beyJ[A-Za-z0-9_-]{6,}\.[A-Za-z0-9_-]{6,}\.[A-Za-z0-9_-]{6,}\b/g, REDACTED_VALUE],
  [/\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/gi, REDACTED_VALUE],
  [/\b[a-f0-9]{32,}\b/gi, REDACTED_VALUE],
  [/\+?[0-9][0-9\s().-]{8,}[0-9]/g, REDACTED_VALUE],
]

const isPlainObject = (value: unknown): value is Record<string, unknown> => {
  if (typeof value !== 'object' || value === null || Array.isArray(value)) {
    return false
  }

  const prototype = Object.getPrototypeOf(value)
  return prototype === Object.prototype || prototype === null || value.constructor === Object
}

const redactString = (value: string): string => {
  return STRING_REDACTORS.reduce((result, [pattern, replacement]) => {
    return result.replace(pattern, replacement)
  }, value)
}

const redactError = (error: Error): Record<string, string | undefined> => {
  return {
    name: redactString(error.name),
    message: redactString(error.message),
    stack: error.stack ? redactString(error.stack) : undefined,
  }
}

const redactValue = (value: unknown, seen: WeakSet<object>): unknown => {
  if (typeof value === 'string') {
    return redactString(value)
  }

  if (value instanceof Error) {
    return redactError(value)
  }

  if (Array.isArray(value)) {
    return value.map(item => redactValue(item, seen))
  }

  if (isPlainObject(value)) {
    if (seen.has(value)) {
      return CIRCULAR_REFERENCE
    }

    seen.add(value)

    const result = Object.keys(value).reduce<Record<string, unknown>>((redactedValue, key) => {
      redactedValue[key] = SENSITIVE_KEY_PATTERN.test(key) ? REDACTED_VALUE : redactValue(value[key], seen)
      return redactedValue
    }, {})

    seen.delete(value)
    return result
  }

  return value
}

export const redactForLogging = (value: unknown): unknown => {
  return redactValue(value, new WeakSet<object>())
}
